import { RouteConfig, Route } from 'vue-router';
import md5 from 'js-md5';
import { Dictionary } from 'vue-router/types/router.d';
import { IOpenTag } from '@/store/state.d';

/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
class Util {
  /**
   * @auth Terry
   * @description 根据 menuRoutes 及 authRotes 计算用户的routes
   * @param { Array<RouteConfig> } routes menuRoutes
   * @param { Array<string> } params server return routesList
   * @returns { Array<RouteConfig> } last result
   */
  static getRouter(routes: Array<RouteConfig>, params: Array<string>,
    viewRoutes: Array<RouteConfig>) {
    let newRoutes: Array<RouteConfig> = [];
    return Util.forEachTree(routes, params, newRoutes, viewRoutes);
  }

  /**
   * @author Terry
   * @description 当打开页面的时候计算导航标签
   * @param { Array<IOpenTag> } tags 已经打开的页面
   * @param route 当前页面路由
   * @returns { Array<IOpenTag> } newTags
   */
  static openPage(tags: Array<IOpenTag>, route: Route) {
    let newTags: Array<IOpenTag> = [...tags];
    if (!tags.some((tag: IOpenTag) => tag.path === route.name)) {
      newTags.push({
        closable: true,
        name: route.meta.name,
        active: true,
        path: route.name as string,
        params: route.params,
      });
      this.setPageActive(tags, route.name as string);
    } else {
      this.setPageActive(tags, route.name as string, route.params);
    }
    return newTags;
  }

  /**
   * @author Terry
   * @description  关闭页面
   * @param { Array<IOpenTag> } tags 已经打开的页面
   * @param { Object } param type 关闭的类型 path 标签路径
   * @returns { Array<IOpenTag> } newTags
   */
  static closePage(tags: Array<IOpenTag>, param: { type: string, path: string }) {
    switch (param.type) {
      case '0': return this.closePageByPath(tags, param.path);
      case '1': return this.closePageByLeft(tags, param.path);
      case '2': return this.closePageByRight(tags, param.path);
      case '3': return this.closeOtherPage(tags, param.path);
      case '4': { tags[0].active = true; return [tags[0]]; }
      default: return tags;
    }
  }

  private static getIndex(tags: Array<IOpenTag>, path: string): number {
    return tags.findIndex((tag: IOpenTag) => tag.path === path);
  }

  private static closePageByPath(tags: Array<IOpenTag>, path: string) {
    let index: number = this.getIndex(tags, path);
    let flag: boolean = false;
    if (tags[index].active) flag = true;
    tags.splice(index, 1);
    if (flag && tags[index]) tags[index].active = true;
    else if (flag) tags[index - 1].active = true;
    return [...tags];
  }

  private static closePageByLeft(tags: Array<IOpenTag>, path: string) {
    let index: number = this.getIndex(tags, path);
    tags.splice(1, index - 1);
    return [...tags];
  }

  private static closePageByRight(tags: Array<IOpenTag>, path: string) {
    let index: number = this.getIndex(tags, path);
    tags.splice(index + 1, tags.length - index);
    return [...tags];
  }

  private static closeOtherPage(tags: Array<IOpenTag>, path: string) {
    let index: number = this.getIndex(tags, path);
    return index === 0 ? [tags[0]] : [tags[0], tags[index]];
  }

  /**
   * @author Terry
   * @description 将当前标签设为激活项
   * @param tags 已经打开的页面
   * @param path 当前路径
   */
  static setPageActive(tags: Array<IOpenTag>, path: string, params?: Dictionary<string>) {
    /* eslint-disable no-param-reassign */
    tags.map((tag: IOpenTag) => {
      if (tag.path === path) tag.active = true;
      if (tag.active && tag.path !== path) tag.active = false;
      if (params && Object.keys(params).length > 0) tag.params = Object.assign({}, params);
      return tag;
    });
  }

  /**
   * @author Terry
   * @description 根据 menuRoutes 及 authRotes 计算用户的routes
   * @param { Array<RouteConfig> } routes menuRoutes
   * @param { Array<string> } routePaths server return routesList
   * @param { Array<RouteConfig> } newRoutes last result
   * @returns { Array<RouteConfig> } last result
   */
  private static forEachTree(routes: Array<RouteConfig>,
    routePaths: Array<string>, newRoutes: Array<RouteConfig>, viewRoutes: Array<RouteConfig>)
    : Array<RouteConfig> {
    for (let i = 0; i < routes.length; i += 1) {
      if (routePaths.includes(routes[i].path) && !routes[i].meta.stair) {
        let route: RouteConfig = {
          name: routes[i].name,
          path: routes[i].path,
          meta: routes[i].meta,
          component: routes[i].component,
          redirect: routes[i].redirect,
          children: [],
        };
        newRoutes.push(route);
        Util.forEachTree(routes[i].children || [], routePaths, route.children || [], viewRoutes);
      } else if (routePaths.includes(routes[i].path) && routes[i].meta.stair) {
        (viewRoutes[0].children as Array<RouteConfig>).push(routes[i]);
      }
    }
    return newRoutes;
  }

  public static async compFileMd5(file: File): Promise<string> {
    const fileReader: FileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    return new Promise((resolve, reject) => {
      try {
        fileReader.onload = (e: any) => {
          const md5Key = md5(e.target.result);
          resolve(md5Key);
        };
      } catch (error) {
        reject(error);
      }
    });
  }

  // 通过后台的数据结构转化为前台的级联组件结构
  public static CompTreeNode(nodes: any, childrenName: string) {
    nodes.forEach((node: any) => {
      if (node.depth !== 0 && node.children.length === 0) delete node[childrenName];
      else Util.CompTreeNode(node.children, childrenName);
    });
    return nodes;
  }
}

export default Util;
